import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { DataStoreService } from './dataStore.service';
import { ThemingService } from './theming.service';
import { LangService } from '../components/lang-bar/lang.service';
import { CookieService } from 'ngx-cookie-service';

import { environment } from '@environment';

import { from, of, Subscription } from 'rxjs';
import { ApiService } from '@shared/services/api.service';

import * as moment from 'moment-timezone';
import { PopupService } from '@shared/modules/popup/services/popup.service';
import { NavigationExtras, Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { HelperUtilityService } from '@shared/services/helper-utility.service';
import { ToastService } from '@shared/modules/toast/services/toast.service';

import ticketAPIConfig from 'src/app/modules/apps/new-ticketing-dashboard/new-ticketing-dashboard-api.config.json';
import { TranslateService } from '@ngx-translate/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

import { DateTimeService } from '@shared/services/date-time.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { LoaderService } from '@shared/components/loader/loader.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommunicationService } from '@shared/services/communication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authenticatedUserSysId: string;
  user: any;
  defaultPreferenceTemplate;
  APIMAccessToken: string;
  APIMTokenExpiryDateTime: any;
  userProfile: any;
  sessionExpiryTime: any;
  adExpiryDateTime: string;
  idleState = 'not-started';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  idleEndSub: Subscription;
  idleTimeoutSub: Subscription;
  idleStartSub: Subscription;
  idleTimeoutWarningSub: Subscription;
  idleKeepAliveSub: Subscription;
  userPreferences: any;
  adAccessTokens: any[] = [];
  APIMTokenExpired: boolean;
  sessionExpiryPopup: any;
  accessTokenPromise: Promise<unknown>;
  appConfig: any;
  authConfig: any;
  APIMAPIConfig: any;
  baseURLConfig: any;
  commonAPIConfig: any;
  prefToast: boolean;
  itsmUserName: any;
  tenantNameFromDropDown: any;
  tenantNameDD: any;
  oauthIssuerConfig: any;
  constructor(
    private dataStore: DataStoreService,
    private themeService: ThemingService,
    private langService: LangService,
    private cookieService: CookieService,
    private apiService: ApiService,
    private popupService: PopupService,
    private router: Router,
    private idle: Idle,
    private keepalive: Keepalive,
    private helperUtilityService: HelperUtilityService,
    private toastService: ToastService,
    private translate: TranslateService,
    private ccService: NgcCookieConsentService,
    private dateTimeService: DateTimeService,
    private runTimeConfigService: RunTimeConfigService,
    private loaderService: LoaderService,
    private oauthService: OAuthService,
    private communicationService: CommunicationService
  ) {
    this.baseURLConfig = this.runTimeConfigService.getConfig('baseURLConfig');
    this.appConfig = this.runTimeConfigService.getConfig('appConfig');
    this.authConfig = this.runTimeConfigService.getConfig('authConfig');
    // this.graphAPIConfig = this.runTimeConfigService.getConfig('graphAPIConfig');
    this.APIMAPIConfig = this.runTimeConfigService.getConfig('APIMConfig');
    this.commonAPIConfig = this.runTimeConfigService.getConfig('commonAPIConfig');
    this.defaultPreferenceTemplate = this.runTimeConfigService.getConfig('defaultPreferenceTemplate');
  }

  cognitoLogout() {
    const clientId = this.oauthIssuerConfig.clientId;

    const logoutUri = encodeURIComponent(window.location.origin + '/auth/logout-ad');

    window.location.href = this.authConfig.cognitoLogout + `?client_id=${clientId}` + `&logout_uri=${logoutUri}`;
  }

  logoutUser() {
    return new Promise<void>((resolve, reject) => {
      this.revokeAPIMAccessToken().then(
        () => {
          if (this.authConfig.authMechanism === 'oauth2-oidc') {
            this.cognitoLogout();
          }
          this.destroySession();
          sessionStorage.clear();
          resolve();
        },
        () => {
          // todo: Display logout error and reject
          if (this.authConfig.authMechanism === 'oauth2-oidc') {
            this.cognitoLogout();
          }
          this.destroySession();
          sessionStorage.clear();
          resolve();
        }
      );
    });
  }

  getTenantListConfig() {
    return this.apiService.get(this.APIMAPIConfig.getTenantListConfig);
  }

  destroySession() {
    this.unSubIdle();
    this.resetAPIMTokenInformation();
    this.userProfile = null;

    this.oauthService.stopAutomaticRefresh();

    localStorage.clear();
    // sessionStorage.clear();

    const r = sessionStorage.getItem('r');
    sessionStorage.clear();
    sessionStorage.setItem('r', r);

    if (this.ccService.hasConsented()) {
      const consentStatus = this.cookieService.get('cookieconsent_status');

      this.cookieService.deleteAll('/', '/');
      this.expireCookies();
      if (consentStatus) {
        // this.cookieService.set('cookieconsent_status', consentStatus, 365);
        this.setCookie('cookieconsent_status', consentStatus, 365);
      }
    } else {
      this.cookieService.deleteAll('/', '/');
      this.expireCookies();
    }
  }

  setCookie(name: string, value: string, days: number) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  expireCookies() {
    if (document.cookie) {
      document.cookie.split(';').forEach((c: any) => {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      });
    }
  }

  checkSession() {
    return new Promise<void>((resolve, reject) => {
      const isIframe = window !== window.parent && !window.opener;
      //
      if (isIframe) {
        resolve();
      }
      if (this.authConfig.authMechanism === 'oauth2-oidc') {
        // console.log(this.oauthService.checkSession());
        this.oauthService.loadDiscoveryDocument().then(() => {
          // this.oauthService.refreshToken().then((res: any) => {
          this.oauthService.tryLogin({}).then(() => {
            if (this.isUserAuthenticatedAD()) {
              // this.oauthService.setupAutomaticSilentRefresh();
              this.getUserProfile().then(() => {
                this.getUserPreferences(false).then((pref: any) => {
                  resolve(pref);
                });
              });
            } else {
              reject();
            }
          });
          // });
        });
      } else {
        this.getUserProfile().then(
          () => {
            if (this.isUserAuthenticatedAD()) {
              this.getUserPreferences(false).then(() => {
                resolve();
              });
            } else {
              reject();
            }
          },
          err => {
            reject(err);
          }
        );
      }
    });
  }

  getUserSysId(checkStatus?: any) {
    // todo: Replace with observable
    return new Promise((resolve, reject) => {
      const userData = this.dataStore.getData(true, this.getAuthenticatedUserId());
      if (userData && userData.userSysId) {
        this.authenticatedUserSysId = userData.userSysId;
      }
      if (this.authenticatedUserSysId) {
        resolve(this.authenticatedUserSysId);
      } else if (!checkStatus) {
        this.getUserProfile()
          .then((userProfile: any) => {
            if (userProfile) {
              this.apiService
                .get(ticketAPIConfig.getUserSysId, {
                  params: {
                    user_alias: userProfile.preferred_username
                  }
                })
                .subscribe(
                  (userDetails: any) => {
                    if (userDetails && userDetails.sys_id) {
                      this.authenticatedUserSysId = userDetails.sys_id;
                      this.apiService
                        .post(ticketAPIConfig.getGroupsBasedOnUser, {
                          id: this.authenticatedUserSysId
                        })
                        .subscribe((assignmentGroups: any) => {
                          const groupSysIdList: any[] = [];
                          assignmentGroups.filter(i => {
                            const data: any = {};
                            data.sys_id = i.assignment_group_id;
                            groupSysIdList.push(data);
                          });
                          this.dataStore.updateData(
                            true,
                            this.getAuthenticatedUserId(),
                            'userSysId',
                            this.authenticatedUserSysId
                          );
                          this.dataStore.updateData(
                            true,
                            this.getAuthenticatedUserId(),
                            'groupSysIdFilter',
                            groupSysIdList
                          );
                        });
                      this.itsmUserName = userDetails.user_name;
                      resolve(this.authenticatedUserSysId);
                      resolve(this.itsmUserName);
                      this.getAuthenticateditsmUserName();
                    } else {
                      this.authenticatedUserSysId = null;
                      reject();
                    }
                  },
                  err => {
                    this.authenticatedUserSysId = null;
                    let navigationExtras: NavigationExtras;
                    if (err && err.status && (err.status === 0 || err.status === 404)) {
                      navigationExtras = {
                        state: {
                          accessError: true
                        }
                      };
                    } else if (err && err.status && (err.status === 401 || err.status === 403)) {
                      navigationExtras = {
                        state: {
                          unauthorizedError: true
                        }
                      };
                    } else {
                      if (err && err.errorCode) {
                        // todo
                        console.error('An error has occured');
                      } else if (this.APIMTokenExpired) {
                        navigationExtras = {
                          state: {
                            apimTokenError: true
                          }
                        };
                      } else {
                        navigationExtras = {
                          state: {
                            sysIdError: true
                          }
                        };
                      }
                    }
                    this.router.navigate(['error'], navigationExtras).then(r => {});
                    reject(err);
                  }
                );
            } else {
              this.authenticatedUserSysId = null;
              // this.toastService.showToast(
              //   "Error retrieving user's sys id, access to ticketing application is blocked!",
              //   'toastError'
              // );

              reject();
            }
          })
          .catch(err => {
            this.authenticatedUserSysId = null;
            // this.toastService.showToast(
            //   "Error retrieving user's sys id, access to ticketing application is blocked!",
            //   'toastError'
            // );

            reject(err);
          });
      } else {
        reject();
      }
    });
  }

  // getUserPrincipalName() {
  //   return new Promise((resolve, reject) => {
  //     this.getUserProfile().then(userProfile => {
  //       resolve(this.userProfile.userPrincipalName);
  //     }).catch(err=> {
  //       reject();
  //     })
  //   });
  // }

  staticUpdateUserPreferences(userPreferences: any) {
    this.userPreferences = JSON.parse(JSON.stringify(userPreferences));
  }

  getUserProfile() {
    return new Promise((resolve, reject) => {
      if (this.authConfig.authMechanism !== 'oauth2-oidc') {
        resolve({});
      } else {
        if (!this.userProfile) {
          // debugger;
          const userProfileData = JSON.parse(localStorage.getItem('id_token_claims_obj'));
          if (userProfileData) {
            this.userProfile = userProfileData;
            resolve(this.userProfile);
          } else {
            this.getUserProfileAD().subscribe(
              profile => {
                // console.log(profile, 'UserProfile');
                this.userProfile = profile;
                resolve(this.userProfile);
              },
              err => {
                // todo: redirect user to login screen with a retry message
                console.log('Cannot fetch user profile due to an error');
                console.log(err);
                const navigationExtras: NavigationExtras = {
                  state: {
                    profileFetchError: true
                  }
                };
                this.router.navigate(['error'], navigationExtras).then(r => {
                  this.userProfile = null;
                });
                reject(err);
              }
            );
          }
        } else {
          this.dataStore.setData(true, this.userProfile.preferred_username, {}, null, true);
          resolve(this.userProfile);
        }
      }
    });
    // this.dataStore.getData(true, this.getAuthenticatedUserId());
  }

  saveUserPreferences(userPref: any, lastLoginTime?: string, updateLastLoginTime?: boolean) {
    if (!userPref) {
      // no existing user preferences found, load from defaults
      this.userPreferences = JSON.parse(JSON.stringify(this.defaultPreferenceTemplate));
      userPref = JSON.parse(JSON.stringify(this.defaultPreferenceTemplate));
    }

    const opts = {
      params: {
        sys_id: this.authenticatedUserSysId,
        createdBy: 'admin'
      }
    };

    if (updateLastLoginTime) {
      const _userPref = JSON.parse(JSON.stringify(this.userPreferences));
      _userPref.log.lastLogin = this.dateTimeService.formatToLongDate(moment());
      return this.apiService.post(this.commonAPIConfig.saveUserPreferences, _userPref, opts);
    }
    if (lastLoginTime) {
      userPref.log.lastLogin = lastLoginTime;
    }
    return this.apiService.post(this.commonAPIConfig.saveUserPreferences, userPref, opts);
  }

  setUserPreferences(userPreferences: any) {
    this.userPreferences = JSON.parse(JSON.stringify(userPreferences));
  }

  setDefaultLang() {
    // set default language
    if (!this.userPreferences.settings.language) {
      if (this.appConfig.availableLanguages.indexOf(this.translate.getBrowserLang()) > -1) {
        this.userPreferences.settings.language = this.translate.getBrowserLang() || 'en';
      } else {
        this.userPreferences.settings.language = 'en';
      }
    }
  }

  getUserPreferences(isFreshLogin?: boolean) {
    return new Promise((resolve, reject) => {
      if (this.authConfig.authMechanism !== 'oauth2-oidc') {
        resolve(this.defaultPreferenceTemplate);
      } else {
        if (this.userPreferences) {
          // this.dateTimeService.setLocale(this.userPreferences.settings.userLocale || 'en');
          // this.dateTimeService.setTimeZone(this.userPreferences.settings.timeZone.split(') ')[1]);

          resolve(this.userPreferences);
        } else {
          this.getUserSysId().then(
            () => {
              this.apiService
                .get(this.commonAPIConfig.getUserPreferences, {
                  params: {
                    sys_id: this.authenticatedUserSysId
                  }
                })
                .subscribe(
                  (res: any) => {
                    let hasPreferenceTemplateChanged;

                    let firstLogin;

                    if (!res || (res && Object.keys(res).length === 0)) {
                      let trans;
                      this.translate.get('lang.authService.welcomeMessage').subscribe((resTrans: any) => {
                        //NOSONAR
                        trans = resTrans;
                      }),
                        // First time login
                        this.toastService.showToast(trans, 'toastInfo', { dontRemoveOnRouteChange: true });
                      firstLogin = true;
                    } else {
                      this.userPreferences = JSON.parse(JSON.stringify(res));

                      // check if existing preferences match the template
                      if (
                        !this.helperUtilityService.deepSameKeys(this.userPreferences, this.defaultPreferenceTemplate)
                      ) {
                        // const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
                        /* this.userPreferences = deepmerge(
                        JSON.parse(JSON.stringify(this.userPreferences)),
                        JSON.parse(JSON.stringify(this.defaultPreferenceTemplate)),
                        { arrayMerge: overwriteMerge }
                      ); */

                        if (!this.prefToast) {
                          console.warn(
                            'Preferences template has changed, overwriting existing preferences to match new template, user has to reconfigure all preferences!'
                          );

                          this.toastService.showToast(
                            'Application has been reconfigured with new preferences. Please reconfigure your preferences in User Profile!',
                            'toastWarning',
                            { dontRemoveOnRouteChange: true }
                          );
                          this.userPreferences = JSON.parse(JSON.stringify(this.defaultPreferenceTemplate));

                          hasPreferenceTemplateChanged = true;
                          this.prefToast = true;
                        }
                      }

                      // todo, check scenarios
                      // if labels have changed
                      // if new properties
                    }

                    this.doPostAuthTasks();

                    if (firstLogin) {
                      this.userPreferences = JSON.parse(JSON.stringify(this.defaultPreferenceTemplate));

                      this.setDefaultLang();
                    }

                    // if (firstLogin || !this.userPreferences.settings.userLocale) {
                    // set default locale (this will be used for application wide format display)
                    if (navigator && navigator.language) {
                      this.userPreferences.settings.userLocale = navigator.language;
                    } else {
                      this.userPreferences.settings.userLocale = this.translate.getBrowserLang() || 'en';
                    }
                    // }

                    // apply locale
                    this.dateTimeService.setLocale(this.userPreferences.settings.userLocale || 'en');

                    if (firstLogin || !this.userPreferences.settings.timeZone) {
                      const timeZones = this.dateTimeService.getTimeZones(true);

                      const offsetTmz = [];
                      for (const i of timeZones) {
                        const timeZoneStr = '(GMT ' + this.dateTimeService.getTimeOffset(i.name) + ') ' + i.name;
                        offsetTmz.push({
                          name: timeZoneStr,
                          value: timeZoneStr,
                          uniqueId: timeZoneStr
                        });
                      }

                      // set default time zone
                      const userTimeZone =
                        '(GMT ' + this.dateTimeService.getTimeOffset() + ') ' + this.dateTimeService.getTimeZone();
                      const userTimeZoneOffset = this.dateTimeService.getTimeOffset();

                      const timeZoneMatch = offsetTmz.find(i => i.name === userTimeZone);
                      const timeZoneOffsetMatch = offsetTmz.find(i => i.name.indexOf(userTimeZoneOffset) > -1);

                      if (timeZoneMatch) {
                        this.userPreferences.settings.timeZone = timeZoneMatch.value;
                      } else if (timeZoneOffsetMatch) {
                        this.userPreferences.settings.timeZone = timeZoneOffsetMatch.value;
                      } else {
                        this.userPreferences.settings.timeZone = 'UTC – Coordinated Universal Time';
                      }
                      const timeZone = this.userPreferences.settings.timeZone.split(') ')[1]
                        ? this.userPreferences.settings.timeZone.split(') ')[1]
                        : 'utc';
                      this.dateTimeService.setTimeZone(timeZone);
                      if (!this.userPreferences.settings.dateFormat) {
                        this.userPreferences.settings.dateFormat = this.dateTimeService.formatToLongDate(
                          new Date(),
                          'L'
                        );
                      }

                      if (!this.userPreferences.settings.timeFormat) {
                        this.userPreferences.settings.timeFormat = this.dateTimeService.formatToLongDate(
                          new Date(),
                          'LT'
                        );
                      }
                    } else {
                      const timeZone = this.userPreferences.settings.timeZone.split(') ')[1]
                        ? this.userPreferences.settings.timeZone.split(') ')[1]
                        : 'utc';
                      this.dateTimeService.setTimeZone(timeZone);
                    }

                    if (isFreshLogin || hasPreferenceTemplateChanged) {
                      this.saveUserPreferences(this.userPreferences, null, true).subscribe(
                        () => {
                          this.applyPreferences();
                          resolve(this.userPreferences);
                        },
                        () => {
                          this.applyPreferences();
                          resolve(this.userPreferences);
                        }
                      );
                    } else {
                      this.saveUserPreferences(this.userPreferences, null, true).subscribe(() => {
                        this.applyPreferences();
                        resolve(this.userPreferences);
                      });
                    }
                  },
                  () => {
                    // could not fetch user preferences, load defaults
                    this.toastService.showToast(
                      'Could not load user preferences, due to an error, loading defaults..',
                      'toastWarning'
                    );
                    this.userPreferences = JSON.parse(JSON.stringify(this.defaultPreferenceTemplate));

                    this.saveUserPreferences(null).subscribe(
                      () => {
                        this.applyPreferences();
                        resolve(this.userPreferences);
                      },
                      () => {
                        this.applyPreferences();
                        resolve(this.userPreferences);
                      }
                    );
                  }
                );
            },
            err => {
              let navigationExtras: NavigationExtras;
              if (err && err.status && (err.status === 0 || err.status === 404)) {
                navigationExtras = {
                  state: {
                    accessError: true
                  }
                };
              } else if (err && err.status && (err.status === 401 || err.status === 403)) {
                navigationExtras = {
                  state: {
                    unauthorizedError: true
                  }
                };
              } else {
                if (err && err.errorCode) {
                  // todo
                  console.error('An unexpected error has occured');
                } else {
                  navigationExtras = {
                    state: {
                      sysIdError: true
                    }
                  };
                }
              }
              this.router.navigate(['error'], navigationExtras).then(r => {});
            }
          );
        }
      }
    });
  }

  applyPreferences() {
    this.themeService.changeTheme(
      this.userPreferences.settings.theme,
      null,
      this.userPreferences.settings.customThemeOptions
    );
    this.langService.switchLanguage(this.userPreferences.settings.language);
  }

  getIdentityClaims() {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return [];
    }
    console.log(claims, 'Available Claims');
    return claims;
  }

  getAuthenticateditsmUserName(): string {
    return this.itsmUserName;
  }

  getAuthenticatedUserId(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return claims['preferred_username'];
  }

  // ** Azure AUTH (WIP) **/

  redirectToADLogin(opt?: string) {
    if (this.authConfig.authMechanism === 'oauth2-oidc') {
      this.oauthService.configure({
        issuer: this.oauthIssuerConfig.issuer,
        clientId: this.oauthIssuerConfig.clientId,
        responseType: this.oauthIssuerConfig.responseType,
        redirectUri:
          this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.redirectUri || this.baseURLConfig.app.baseURL,
        postLogoutRedirectUri: this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.postLogoutRedirectUri,
        silentRefreshRedirectUri: this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.silentRefreshRedirectUri,
        scope: this.oauthIssuerConfig.scope,
        silentRefreshShowIFrame: this.oauthIssuerConfig.useSilentRefresh,
        silentRefreshTimeout: this.oauthIssuerConfig.silentRefreshTimeout,
        timeoutFactor: this.oauthIssuerConfig.timeoutFactor,
        sessionChecksEnabled: this.oauthIssuerConfig.sessionChecksEnabled,
        showDebugInformation: this.oauthIssuerConfig.showDebugInformation,
        clearHashAfterLogin: this.oauthIssuerConfig.clearHashAfterLogin,
        nonceStateSeparator: this.oauthIssuerConfig.nonceStateSeparator,
        strictDiscoveryDocumentValidation: this.oauthIssuerConfig.strictDiscoveryDocumentValidation,
        requireHttps: false,
        skipIssuerCheck: true,
        disablePKCE: false,
        customQueryParams: {
          identity_provider: 'PingFederate'
        }
      });

      // this.oauthService.customQueryParams = {
      //   identity_provider: 'PingFederate'
      // };
      let tenantName = this.tenantNameDD;

      this.oauthService
        .loadDiscoveryDocument()
        .then(() => {
          console.log('Discovery loaded');
          console.log('Login URL:', this.oauthService.loginUrl);

          this.oauthService.initLoginFlow(
            JSON.stringify({
              tenant: tenantName
            })
          );
        })
        .catch(err => {
          console.error('Discovery load failed', err);
        });

      // this.oauthService.initLoginFlow();
    } else {
      this.authenticatedUserSysId = 'none';
      return;
    }
  }

  public runInitialLoginSequence(): Promise<void> {
    if (location.hash) {
      console.log('Encountered hash fragment, plotting as table...');
      console.table(
        location.hash
          .substr(1)
          .split('&')
          .map(kvp => kvp.split('='))
      );
    }
    this.oauthService.configure({
      issuer: this.oauthIssuerConfig.issuer,
      clientId: this.oauthIssuerConfig.clientId,
      responseType: this.oauthIssuerConfig.responseType,
      redirectUri:
        this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.redirectUri || this.baseURLConfig.app.baseURL,
      postLogoutRedirectUri: this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.postLogoutRedirectUri,
      silentRefreshRedirectUri: this.baseURLConfig.app.baseURL + this.oauthIssuerConfig.silentRefreshRedirectUri,
      scope: this.oauthIssuerConfig.scope,
      silentRefreshShowIFrame: this.oauthIssuerConfig.useSilentRefresh,
      silentRefreshTimeout: this.oauthIssuerConfig.silentRefreshTimeout,
      timeoutFactor: this.oauthIssuerConfig.timeoutFactor,
      sessionChecksEnabled: this.oauthIssuerConfig.sessionChecksEnabled,
      showDebugInformation: this.oauthIssuerConfig.showDebugInformation,
      clearHashAfterLogin: this.oauthIssuerConfig.clearHashAfterLogin,
      nonceStateSeparator: this.oauthIssuerConfig.nonceStateSeparator,
      strictDiscoveryDocumentValidation: this.oauthIssuerConfig.strictDiscoveryDocumentValidation,
      requireHttps: false,
      skipIssuerCheck: true,
      disablePKCE: false
    });

    this.oauthService.customQueryParams = {
      identity_provider: 'PingFederate'
    };
    // 0. LOAD CONFIG:
    // First we have to check to see how the IdServer is
    // currently configured:
    return (
      this.oauthService
        .loadDiscoveryDocument()

        // 1. HASH LOGIN:
        // Try to log in via hash fragment after redirect back
        // from IdServer from initImplicitFlow:
        // { disableOAuth2StateCheck: true }
        .then(() => {
          return this.oauthService.tryLogin({});
        })

        .then(() => {
          const state = this.oauthService.state;
          if (state) {
            const stateData = JSON.parse(decodeURIComponent(state));
            console.log(stateData.tenant);
            this.tenantNameFromDropDown = stateData.tenant;
          }
          if (this.oauthService.hasValidAccessToken()) {
            return Promise.resolve();
          }

          if (!this.isUserAuthenticatedAD()) {
            return Promise.resolve();
          } else {
            // 2. SILENT LOGIN:
            // Try to log in via a refresh because then we can prevent
            // needing to redirect the user:
            return this.oauthService
              .silentRefresh()
              .then(() => {
                Promise.resolve();
              })
              .catch(result => {
                // Subset of situations from https://openid.net/specs/openid-connect-core-1_0.html#AuthError
                // Only the ones where it's reasonably sure that sending the
                // user to the IdServer will help.
                const errorResponsesRequiringUserInteraction = [
                  'interaction_required',
                  'login_required',
                  'account_selection_required',
                  'consent_required'
                ];

                if (
                  result &&
                  result.reason &&
                  errorResponsesRequiringUserInteraction.indexOf(result.reason.error) >= 0
                ) {
                  // 3. ASK FOR LOGIN:
                  // At this point we know for sure that we have to ask the
                  // user to log in, so we redirect them to the IdServer to
                  // enter credentials.
                  //
                  // Enable this to ALWAYS force a user to login.
                  // this.login();
                  //
                  // Instead, we'll now do this:
                  console.warn('User interaction is needed to log in, we will wait for the user to manually log in.');
                  return Promise.resolve();
                }

                // We can't handle the truth, just pass on the problem to the
                // next handler.
                return Promise.reject(result);
              });
          }
        })

        .then(() => {
          // this.isDoneLoadingSubject$.next(true);

          // Check for the strings 'undefined' and 'null' just to be sure. Our current
          // login(...) should never have this, but in case someone ever calls
          // initImplicitFlow(undefined | null) this could happen.
          if (
            this.oauthService.state &&
            this.oauthService.state !== 'undefined' &&
            this.oauthService.state !== 'null'
          ) {
            const decodedState = decodeURIComponent(this.oauthService.state);
            if (decodedState.startsWith('{')) {
              const stateData = JSON.parse(decodedState);
              this.tenantNameFromDropDown = stateData.tenant;
              console.log('Tenant:', this.tenantNameFromDropDown);
            }
            // let stateUrl = this.oauthService.state;
            // if (stateUrl.startsWith('/') === false) {
            //   stateUrl = decodeURIComponent(stateUrl);
            // }
            // console.log(`There was state of ${this.oauthService.state}, so we are sending you to: ${stateUrl}`);
            // this.router.navigateByUrl(stateUrl);
          }
        })
        .catch(result => {
          // this.isDoneLoadingSubject$.next(true)
        })
    );
  }

  /*
  The reason why a network request is made is because you are including scopes that span multiple resources (https://api-uri scope is
  for your custom resource and openid and profile is for graph). Access tokens are scoped per resource and the library caches access tokens accordingly.
  This means that when you try to acquire a token for scopes that span multiple resources it will always result in a cache miss.
  The solution is to make separate acquireTokenSilent calls for each resource.
  A single call to acquireTokenSilent with your custom scope should get you the access token you need.
   */
  getTokenAD() {
    return new Promise((resolve, reject) => {
      if (this.authConfig.authMechanism === 'oauth2-oidc') {
        resolve({ idToken: this.oauthService.getIdToken() });
      } else {
        resolve({});
      }
    });
  }

  isUserAuthenticatedAD() {
    if (this.authConfig.authMechanism === 'oauth2-oidc') {
      return this.oauthService.hasValidAccessToken();
    } else if (this.authenticatedUserSysId || !this.authConfig.authMechanism) {
      return true;
    }
  }

  getUserGroupsAd() {
    return of({});
  }

  getUserGroupsAPIM() {
    return new Promise((resolve, reject) => {
      if (this.authConfig.authMechanism !== 'oauth2-oidc') {
        resolve([]);
      } else {
        this.getAccessTokenAPIM().then(
          (accessToken: any) => {
            if (accessToken) {
              console.log(this.tenantNameFromDropDown);
              const parsedToken = this.helperUtilityService.parseJWT(accessToken);
              if (parsedToken.eaf_groups && Array.isArray(parsedToken.eaf_groups)) {
                parsedToken.eaf_groups.forEach((group, i) => {
                  parsedToken.eaf_groups[i] = group.replace(/\[/g, '').replace(/]/g, '');
                });
                resolve(
                  parsedToken.eaf_groups.filter(g => {
                    return g.indexOf('Internal/') > -1;
                  })
                );
              } else if (
                parsedToken.eaf_groups &&
                parsedToken.eaf_groups.length > 0 &&
                !Array.isArray(parsedToken.eaf_groups)
              ) {
                const g = parsedToken.eaf_groups.replace(/\[/g, '').replace(/]/g, '');
                if (g.indexOf('Internal/') > -1) {
                  resolve([g]);
                } else {
                  reject();
                }
              } else {
                reject();
              }
            }
          },
          err => {
            reject(err);
          }
        );
      }
    });
  }

  revokeAPIMAccessToken() {
    return new Promise<void>((resolve, reject) => {
      if (this.authConfig.authMechanism !== 'oauth2-oidc') {
        resolve();
      } else {
        this.dataStore.removeData(true, this.getAuthenticatedUserId(), 'APIMRT');
        if (this.APIMAccessToken) {
          const body = new HttpParams()
            .set('token', this.APIMAccessToken)
            .set('token_type_hint', 'access_token')
            .set('client_id', this.authConfig.APIM.clientId);
          // add client id and client secret in headers
          const headers = new HttpHeaders();
          // headers = headers.append(
          //   'Authorization',
          //   'Basic ' + window.btoa(this.authConfig.APIM.clientId + ':' + this.authConfig.APIM.clientSecret)
          // );

          let td = {};

          if (this.authConfig.APIM.domain) {
            td = {
              tenantDomain: this.authConfig.APIM.domain
            };
          }

          this.apiService
            .post(this.APIMAPIConfig.revokeAccessToken, body, {
              params: td,
              headers,
              withCredentials: environment.staging || environment.production ? true : false
            })
            .subscribe(
              () => {
                resolve();
              },
              err => {
                resolve();
              }
            );
        } else {
          resolve();
        }
      }
    });
  }

  showSessionExpiryPopup(title?: string, reason?: string, dismissAllPopups?: boolean) {
    let messageText;
    if (reason) {
      if (reason === 'inactivity' || reason === 'authentication failure') {
        messageText = 'Your session has expired due to ' + reason + ', please login again.';
      } else {
        messageText = reason;
      }
    } else {
      messageText = 'Your session has expired, please choose to Continue Working or Logout to end session.';
    }

    if (dismissAllPopups) {
      this.popupService.dismissAllPopups(reason);
    }

    if (reason && (reason === 'inactivity' || reason === 'authentication failure')) {
      return this.popupService.showMessagePopup(
        title || 'Session Expired',
        messageText,
        {
          type: 'error'
        },
        {
          actionButton: { buttonLabel: 'Ok' }
        }
      );
    } else {
      return this.popupService.showConfirmationPopup('Login Error', messageText, {
        cancelButton: {
          buttonLabel: 'Continue Working'
        },
        confirmButton: {
          buttonLabel: 'Ok'
        }
      });
    }
  }

  hasAPIMTokenExpired() {
    if (this.authConfig.authMechanism !== 'oauth2-oidc') {
      return false;
    }
    const accessTokenExpiry = this.dataStore.getData(true, 'APIMTokenExpiry');
    if (accessTokenExpiry) {
      this.APIMTokenExpiryDateTime = new Date(accessTokenExpiry);
      if (this.APIMTokenExpiryDateTime && this.dateTimeService.getCurrentDateTime() > this.APIMTokenExpiryDateTime) {
        this.APIMTokenExpired = true;
        // popupInstance.result.then(data => {
        //   this.destroySession();
        //   // APIM Token has expired, signing out user
        //   this.logoutUser();
        // });
        return true;
      }
    } else {
      return false;
    }
  }

  getAccessTokenAPIM(fetchNewToken?: boolean) {
    const session_accessToken = this.dataStore.getData(true, 'AccessToken');
    const userData = this.dataStore.getData(true, this.getAuthenticatedUserId());
    if (this.sessionExpiryPopup && this.accessTokenPromise) {
      return this.accessTokenPromise;
    }

    this.accessTokenPromise = new Promise((resolve, reject) => {
      if (!fetchNewToken && this.hasAPIMTokenExpired()) {
        this.APIMAccessToken = null;
        const navigationExtras: NavigationExtras = {
          state: {
            accessTokenExpired: true
          }
        };
        this.loaderService.hide();
        this.destroySession();
        this.toastService.clearAllToasts();
        window.location.replace('auth/login-ad');
        reject();
        // setTimeout(() => {
        //   this.sessionExpiryPopup = this.showSessionExpiryPopup();
        //   // this.loaderService.hide();
        // });
        // this.sessionExpiryPopup.result.then(logoutButtonClicked => {
        //   this.sessionExpiryPopup = null;
        //   if (logoutButtonClicked) {
        //     this.destroySession();
        //     this.logoutUser();

        //     this.accessTokenPromise = null;
        //     reject(new Error('APIMTokenExpired'));
        //   } else {
        //     this.getAccessTokenAPIM(true).then(() => {
        //       this.toastService.showToast('Your session has been extended successfully!', 'toastAcknowledgement');

        //       this.accessTokenPromise = null;
        //       resolve(this.APIMAccessToken);
        //     });
        //   }
        // });
      } else {
        if (this.APIMAccessToken) {
          this.accessTokenPromise = null;
          resolve(this.APIMAccessToken);
        } else {
          if (session_accessToken) {
            // this.accessTokenPromise = new Promise((resolve, reject) => {
            //   console.log('getAccessTokenAPIM inside promise', session_accessToken);
            this.APIMAccessToken = session_accessToken;
            this.accessTokenPromise = null;
            resolve(this.APIMAccessToken);
            //   });
          } else {
            this.getTokenAD()
              .then((adResponse: any) => {
                sessionStorage.setItem('tenant_name_state', this.tenantNameFromDropDown);
                let tenantNameState: any = sessionStorage.getItem('tenant_name_state');
                if (adResponse && adResponse.idToken) {
                  // const tenant_name = this.helperUtilityService.parseJWT(adResponse.idToken);
                  // this.cookieService.set('JWTToken', adResponse.idToken, 365, '/', '/', true, 'Strict');
                  // sessionStorage.setItem('tenantname', this.tenantNameDD);
                  // got the AD Access Token, proceed to get one from APIM
                  const userDat = this.dataStore.getData(true, this.getAuthenticatedUserId());
                  let body;
                  if (userDat && userDat.APIMRT) {
                    body = new HttpParams().set('grant_type', 'refresh_token').set('refresh_token', userData.APIMRT);
                  } else {
                    body = new HttpParams()
                      .set('grant_type', this.authConfig.APIM.grantType)
                      .set('assertion', adResponse.idToken)
                      .set('scope', this.authConfig.APIM.accessScopes.join(' '))
                      .set('client_id', this.authConfig.APIM.clientId);
                  }

                  // add client id and client secret in headers
                  let headers = new HttpHeaders();
                  const customClaimConfig = this.authConfig.APIM['custom_claim_flag'];
                  // headers = headers.append(
                  //   'Authorization',
                  //   'Basic ' + window.btoa(this.authConfig.APIM.clientId + ':' + this.authConfig.APIM.clientSecret)
                  // );
                  if (customClaimConfig !== null) {
                    headers = headers.append('custom_claim_flag', [customClaimConfig]);
                    // headers = headers.append('tenant_name', tenant_name.given_name);
                    headers = headers.append('tenant_name', tenantNameState);
                  }
                  // headers = headers.append('Cache-Control','no-cache');

                  let td = {};

                  if (this.authConfig.APIM.domain) {
                    td = {
                      tenantDomain: this.authConfig.APIM.domain
                    };
                  }

                  let iat = 0;
                  if (this.oauthService.getIdentityClaims()['iat']) {
                    iat = this.oauthService.getIdentityClaims()['iat'] * 1000; // not before claim
                    // console.log('IAT (MS): ' + iat + ' // Current time (MS): ' + new Date().getTime());
                    // console.log('IAT Date/Time: ' + new Date(iat));
                    // console.log('Current Date/Time: ' + new Date());

                    if (iat - new Date().getTime() > 0) {
                      console.log(
                        'APIM Token request will be made after: ' + (iat - new Date().getTime()) / 1000 + ' seconds.'
                      );
                    } else {
                      console.log(
                        'APIM Token request will be made immediately as IAT claim time is met (' +
                          (iat - new Date().getTime()) / 1000 +
                          ').'
                      );
                    }
                    // console.log('Diff (Secs): ' + (iat - new Date().getTime()) / 1000);
                  }

                  // Get APIM token only when IAT has passed
                  setTimeout(() => {
                    this.apiService
                      .post(this.APIMAPIConfig.getAccessToken, body, {
                        params: td,
                        headers,
                        withCredentials: environment.staging || environment.production ? true : false
                      })
                      .subscribe(
                        (authResponse: any) => {
                          if (authResponse && authResponse.access_token) {
                            const parsedJWT = this.helperUtilityService.parseJWT(authResponse.access_token);
                            if (parsedJWT) {
                              this.APIMAccessToken = authResponse.access_token;
                              this.dataStore.setData(true, 'AccessToken', this.APIMAccessToken, null, true);
                              this.APIMTokenExpired = false;
                              // if (authResponse.expires_in) {
                              //   this.APIMTokenExpiryDateTime = moment(parsedJWT.exp * 1000);
                              // } else {
                              this.APIMTokenExpiryDateTime = moment(parsedJWT.exp * 1000);
                              // }
                              this.dataStore.setData(true, 'APIMTokenExpiry', this.APIMTokenExpiryDateTime, null, true);
                              if (this.hasAPIMTokenExpired()) {
                                this.resetAPIMTokenInformation();
                                reject();
                              } else {
                                if (userData && userData.APIMRT) {
                                  this.dataStore.updateData(
                                    true,
                                    this.getAuthenticatedUserId(),
                                    'APIMRT',
                                    authResponse.refresh_token
                                  );
                                } else {
                                  this.dataStore.setData(
                                    true,
                                    this.getAuthenticatedUserId(),
                                    {
                                      APIMRT: authResponse.refresh_token
                                    },
                                    null,
                                    true
                                  );
                                }
                                this.accessTokenPromise = null;
                                resolve(this.APIMAccessToken);
                              }
                            } else {
                              // JWT Access Token is invalid
                              console.error('JWT Access Token is invalid!');

                              const navigationExtras: NavigationExtras = {
                                state: {
                                  apimTokenError: true
                                }
                              };
                              this.router.navigate(['error'], navigationExtras).then(r => {});
                            }
                          } else {
                            this.resetAPIMTokenInformation();
                            this.accessTokenPromise = null;
                            reject();
                          }
                        },
                        res => {
                          console.error(res);
                          console.log(res);
                          this.resetAPIMTokenInformation();

                          if (
                            res &&
                            res.error &&
                            (res.status === 400 || (res.error.error && res.error.error === 'invalid_grant'))
                          ) {
                            setTimeout(() => {
                              this.destroySession();
                              this.toastService.clearAllToasts();
                              const navigationExtras: NavigationExtras = {
                                state: {
                                  APIMTokenError: true,
                                  errorMessage: res.error.error_description
                                }
                              };

                              this.router.navigate(['auth/login-ad'], navigationExtras);
                            });
                          } else {
                            const navigationExtras: NavigationExtras = {
                              state: {
                                apimTokenError: true,
                                message: res.error_description
                              }
                            };
                            this.router.navigate(['error'], navigationExtras).then(r => {});
                          }
                          this.accessTokenPromise = null;
                          reject(res);
                        }
                      );
                  }, iat - new Date().getTime());
                }
              })
              .catch(error => {
                // if (error.status === 401) {
                //   this.toastService.showToast('Your account is not onboarded to EAF', 'toastError');
                // }
              });
          }
        }
      }
    });

    return this.accessTokenPromise;
  }

  resetAPIMTokenInformation() {
    this.APIMAccessToken = null;
    this.APIMTokenExpiryDateTime = null;
    this.dataStore.removeData(true, 'APIMTokenExpiry', null);
  }

  setSessionExpiry(expiryDateTime?: any) {
    if (this.idleState === 'started') {
      return;
    }
    if (!expiryDateTime) {
      expiryDateTime = moment().add(1, 'hours');
    }
    console.info('Your session is set to expire on ' + moment(expiryDateTime).format('MMMM Do YYYY, h:mm:ss A'));

    this.adExpiryDateTime = expiryDateTime; // currently not using this, can be used in future.
    this.setIdleTimeout(true);
  }

  resetIdle() {
    this.idle.watch();
    this.idleState = 'started';
    this.timedOut = false;
  }

  setIdleTimeout(noConsole?: boolean) {
    const idleDelaySecs = environment.local ? 1600 : 900;
    const idleTimeout = environment.local ? 1600 : 900;

    // this.idle.setIdleName('sessionIdleHandler');
    this.idle.setIdle(idleDelaySecs);
    // sets a timeout period of idleTimeout seconds. after idleDelaySecs+idleTimeout seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(idleTimeout);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    console.info(
      'Idle timeout to happen at ' +
        moment()
          .add(idleDelaySecs + idleTimeout, 'seconds')
          .format('MMMM Do YYYY, h:mm:ss A')
    );

    this.unSubIdle(noConsole); // Unsub existing to avoid memory leaks

    this.idleEndSub = this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'no-longer-idle';
      console.log('You are no longer idle!');

      this.resetIdle();
      this.toastService.clearAllToasts();
      console.info(
        'Idle timeout to happen at ' +
          moment()
            .add(idleDelaySecs + idleTimeout, 'seconds')
            .format('MMMM Do YYYY, h:mm:ss A')
      );
      this.toastService.showToast('Your session is now resumed!', 'toastAcknowledgement', {
        clearToasts: true
      });
    });

    this.idleTimeoutSub = this.idle.onTimeout.subscribe(() => {
      this.idleState = 'timed-out';
      this.timedOut = true;
      console.log('Your session has timed-out due to inactivity!');

      this.destroySession();
      this.toastService.clearAllToasts();
      const navigationExtras: NavigationExtras = {
        state: {
          sessionTimedout: true
        }
      };

      this.router.navigate(['auth/login-ad'], navigationExtras);
      // popupInstance.result.then(data => {
      //   this.logoutUser();
      // });
    });

    this.idleStartSub = this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'idle';
      console.info(
        'Idle timeout to happen at ' +
          moment()
            .add(idleTimeout, 'seconds')
            .format('MMMM Do YYYY, h:mm:ss A')
      );
    });

    this.idleTimeoutWarningSub = this.idle.onTimeoutWarning.subscribe(countdown => {
      this.idleState = 'session-expiring';
      this.toastService.showToast(
        'Your session will time out in ' +
          moment.utc(countdown * 1000).format('mm:ss') +
          ' minutes! Performing any action will cancel this.',
        'toastInfo',
        {
          clearToasts: true
        }
      );
    });

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.idleKeepAliveSub = this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.resetIdle();
  }

  unSubIdle(noConsole?: boolean) {
    if (!noConsole) {
      console.log('Idle session timer has been stopped!');
    }

    this.idle.stop();
    this.idle.onTimeout.observers.length = 0;
    this.idle.onIdleStart.observers.length = 0;
    this.idle.onIdleEnd.observers.length = 0;
    if (this.idleKeepAliveSub) {
      this.idleKeepAliveSub.unsubscribe();
    }
    if (this.idleTimeoutWarningSub) {
      this.idleTimeoutWarningSub.unsubscribe();
    }
    if (this.idleStartSub) {
      this.idleStartSub.unsubscribe();
    }
    if (this.idleEndSub) {
      this.idleEndSub.unsubscribe();
    }
    if (this.idleTimeoutSub) {
      this.idleTimeoutSub.unsubscribe();
    }
  }

  getUserProfileStatic() {
    return this.userProfile;
  }

  doPostAuthTasks() {
    // chat bot to show based on user preference
    this.getUserPreferences().then((res: any) => {
      // this code is for opening chatbot automatically if turned on in user preferences
      if (res && res.settings.autoOpenChatBotOnLogin === 'true') {
        setTimeout(() => {
          console.warn('Chat bot has been invoked as per user preference.');
          this.communicationService.sendMessage({ chatBot: 'open' });
        }, 20000);
      } else {
        console.warn("Chat bot won't be auto triggered as it is disabled in user preferences.");
      }
    });

    // anything that needs to be invoked post auth can go below this
  }

  private getUserProfileAD() {
    if (this.authConfig.authMechanism === 'oauth2-oidc') {
      return of(this.oauthService.loadUserProfile());
    } else {
      return of({});
    }
  }

  private getCookieExpiryDate(validForDays: number) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + validForDays);
    return expiryDate;
  }
}
